import styled from 'styled-components/macro';
import { device } from 'utils/helpers/deviceScreen';

export const Container = styled.div`
  display: flex;
  row-gap: 4rem;
  flex-direction: column;
  @media ${device.tablet} {
    row-gap: 5rem;
  }
`;

export const CardsList = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  @media ${device.tablet} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: unset;
    gap: 3rem;
  }
`;
